module.exports = __webpack_public_path__ + "img/Kid Warrior Gaming Logo p.jpg";